import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { take, tap } from 'rxjs';
import { concessionsActions } from '../actions/concessions.actions';
import { selectAuthEndsConcessions, selectEnabledConcessions, selectPaymentEndsConcessions } from '../selectors/concessions.selector';
import { ConcessionId } from '../models';

@Injectable({
    providedIn: 'root',
})
export class ConcessionsFacade {
    private readonly store = inject(Store);

    paymentEndsConcessions$ = this.store.select(selectPaymentEndsConcessions);
    authEndsConcessions$ = this.store.select(selectAuthEndsConcessions);

    get enabledConcessions(): ConcessionId[] {
        let value: ConcessionId[] = [];
        this.store
            .select(selectEnabledConcessions)
            .pipe(
                take(1),
                tap((concessions) => (value = concessions)),
            )
            .subscribe();
        return value;
    }

    getConcessions(): void {
        this.store.dispatch(concessionsActions.getConcessions());
    }

    clear(): void {
        this.store.dispatch(concessionsActions.clear());
    }
}
